import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StatusField } from '@ukam/core/models/status-field';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  templateUrl: './status-badge.component.html',
  imports: [DatePipe],
  host: { style: 'display: contents' },
})
export class AppStatusBadgeComponent {
  @Input() status?: StatusField | null;
}
